import React from 'react';
import UserData from './UserData';
import ChangePasswordModal from './ChangePasswordModal';
import styles from './MyAccount.module.css';

const ProfilePage = () => {
  const [showModal, setShowModal] = React.useState(false);

  return (
    <div className={styles.container}>
      <div className={styles.profileCard}>
        <h1 className={styles.title}>My Profile</h1>
        <UserData />
        <button 
          className={styles.changePasswordBtn}
          onClick={() => setShowModal(true)}
        >
          Change Password
        </button>
      </div>

      {showModal && (
        <ChangePasswordModal onClose={() => setShowModal(false)} />
      )}
    </div>
  );
};

export default ProfilePage;